<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">{{ departamento.id ? 'Editar' : 'Adicionar' }} Departamento</div>
            </div>
            <div class="card-body">
              <hr />
              <br />
              <div class="row">
                <div class="col-md-12">
                  <form action />
                  <div class="form-row">
                    <div class="col-md-8">
                      <label for="nome">
                        <span class="required">*</span> Nome:
                      </label>
                      <input autocomplete="new-password" type="text" id="nome" class="form-control" v-model="departamento.nome"
                        placeholder="" />
                    </div>
                    <div class="col-md-4">
                      <label for="status">
                        <span class="required">*</span> Status:
                      </label>
                      <select v-model="departamento.status" class="form-control">
                        <option value="1">Ativo</option>
                        <option value="0">Inativo</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row mt-1">
                    <div class="col-md-12">
                      <label for="descricao">Descrição:</label>
                      <textarea id="descricao" class="form-control" rows="2" v-model="departamento.descricao"></textarea>
                    </div>
                  </div>
                  <div class="form-row mt-1">
                    <div class="col-md-6">
                      <label for="mensagem_saudacao">
                        Mensagem de saudação:
                        <small class="text-muted" v-pre>(pode usar {{contato.nome}})</small>
                      </label>
                      <textarea id="mensagem_saudacao" class="form-control" rows="3" v-model="departamento.mensagem_saudacao"></textarea>
                    </div>
                    <div class="col-md-6">
                      <label for="mensagem_fora_horario">Mensagem fora do horário:</label>
                      <textarea id="mensagem_fora_horario" class="form-control" rows="3" v-model="departamento.mensagem_fora_horario"></textarea>
                    </div>
                  </div>
                  <hr>
                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong> Campos obrigatórios</strong>
                  </span>
                  <div class="form-group mt-1">
                    <div class="block text-right">
                      <router-link to="/departamentos" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                      <a class="btn btn-add ml-1" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "departamentoAdd",
  data() {
    return {
      departamento: {
        status: '1'
      },
      errors: undefined,
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "departamentos";

      if (self.departamento.id) {
        self.departamento._method = "PUT"
        api += "/" + self.departamento.id;
      }

      axios
        .post(api, self.departamento)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/departamentos");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getDepartamento: function (id) {
      const self = this;
      const api = self.$store.state.api + "departamentos/" + id;

      axios
        .get(api)
        .then((response) => {
          self.departamento = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    if (id) {
      self.getDepartamento(id);
    }
  },
};
</script>
